<div class="filter-date-picker">
	<!-- <input
		type="text"
		name="dateInput"
		class="form-control"
		[value]="currentDate"
		daterangepicker
		[options]="rangePickerOptions"
		(selected)="selectedDate($event)"
		required="required"
	/> -->

	<span class="bar"></span>
	<label for="dateInput">{{ fieldName }}</label>
</div>
